import { render, staticRenderFns } from "./AddPaymentTerm.vue?vue&type=template&id=72798690&"
import script from "./AddPaymentTerm.vue?vue&type=script&lang=js&"
export * from "./AddPaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports